/**
 * sentiment question (admin)
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

class SentimentQuestion extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    const { question } = this.props;

    const generalOptions = [1, 2, 3, 4, 5]; 
    const confidenceOptions = Array.from({length: 10}, (_, i) => i + 1); 

    if(question.ratingType == 'thumbs') {
      return ( 
        <div className="yt-col full" style={{paddingBottom: 30, paddingLeft: 10, paddingRight: 10}}>
          <p style={{textAlign: 'center'}}>{question.text}</p>
          <div className="yt-row center-horiz">
              <button className="rating-btn" onClick={null}>
              <img style={{height: 20, width: 20, color: '#fff', marginRight: 15}} src={'/img/thumbs_up.png'}/>
              </button>
              <button className="rating-btn" onClick={null}>
              <img style={{height: 20, width: 20, color: '#fff', marginLeft: 15}} src={'/img/thumbs_down.png'}/>
              </button>
          </div>
        </div>
      )
    } else if(question.ratingType == 'stars') {
      return (
        <div className="yt-col _50" style={{paddingBottom: 30, paddingLeft: 10, paddingRight: 10}}>
          <p style={{textAlign: 'left'}}>{question.text}</p>
          <div className="yt-row">
              { generalOptions.map((option, i) => 
              <button key={i} className="rating-btn" onClick={null}>
                  <img style={{height: 25, width: 25, color: '#fff'}} src={'/img/star.png'}/>
              </button>
              )}
          </div>
        </div>
      )
    } else if(question.ratingType == 'confidence') {
      return (
        <div className="yt-col full" style={{paddingBottom: 30, paddingLeft: 10, paddingRight: 10}}>
          <p style={{textAlign: 'center'}}>{question.text}</p>
          <div className="yt-row center-horiz space-between u-centerText">
              {confidenceOptions.map((option, i) =>
              <div key={i}>
                  <button onClick={null} className="confidence-btn center-vert">
                  <p style={{paddingTop: 4}}>{option}</p>
                  </button>
              </div>
              )}
          </div>
        </div>
      )
    } else null 
  }
}

SentimentQuestion.propTypes = {
  question: PropTypes.object.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sentimentQuestionStore: store.sentimentQuestion
  }
}

export default connect(
    mapStoreToProps
  )(SentimentQuestion);



// WEBPACK FOOTER //
// modules/sentimentQuestion/components/SentimentQuestion.js.jsx